/*!
* Import Alpine.js
*/
import Alpine from 'alpinejs';

/*!
* Import Marked.js for Markdown rendering
*/
import { marked } from 'marked';


import dayjs from 'dayjs';

import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import localeData from 'dayjs/plugin/localeData';

// Locales de Day.js
import 'dayjs/locale/es';
import 'dayjs/locale/en';

// Configurar plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(localeData);

/*!
* Import Tailwind CSS
*/
import '../css/main.css';

/*! ============================================
 * MATERIAL DESIGN 2 - ALPINE.JS COMPONENTS
* ============================================
*/

// Import Material Design components (only used ones)
import {
    registerToastManager,
    injectToastContainer,
    registerDrawer,
    registerModalCommon,
    registerThemeToggle,
    registerClipboard,
    registerNavbarClock
} from './components/material/index';

// Import charts
import { initCharts } from './components/charts/index';

// Import dashboard components
import { initDashboardComponents } from './components/dashboard/index';

// Import stores
import { registerNavigationStore, initNavigationTracking } from './stores/navigation';
import { registerUserDataStore, initUserDataStore } from './stores/user-data';
import { registerI18nStore } from './stores/i18n';

// Import utils
import { initGlobalToast } from './utils/toast-global';
import { processWcNotices } from './utils/wc-notices';

// Import components
import { registerCountdownTimer } from './components/countdown-timer';
import { registerSelect2Bridge } from './components/select2-bridge';

export function initializeApp($user: any) {

    // Initialize Alpine
    (window as any).Alpine = Alpine;

    // Expose marked globally for Alpine components
    (window as any).marked = marked;

    // Expose dayjs globally for Alpine components
    (window as any).dayjs = dayjs;

    // Register Material Design components (only used ones)
    registerDrawer();
    
    registerToastManager();

    registerModalCommon();

    registerThemeToggle();

    registerClipboard();

    registerNavbarClock();

    // Register stores
    registerNavigationStore();
    registerUserDataStore($user);
    registerI18nStore();

    // Register countdown timer
    registerCountdownTimer();

    // Register Select2 bridge
    registerSelect2Bridge();

    // Register dashboard components
    initDashboardComponents();

    // Inject Toast Container
    injectToastContainer();

    // Initialize user data store
    initUserDataStore();

    // Initialize navigation tracking
    initNavigationTracking();

    // Initialize global toast function
    initGlobalToast();

    // Initialize charts
    initCharts();

    Alpine.start();

    // Process WooCommerce notices
    processWcNotices();

}

// Exponer initializeApp globalmente
(window as any).initializeApp = initializeApp;
